import { initialState } from './reducers';
import configureStore from './store';

export default configureStore;

export { initialState };
